import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto max-w-4xl my-7 p-0 min-h-screen" }
const _hoisted_2 = { class: "w-full px-2 py-4 mx-auto text-center" }
const _hoisted_3 = { class: "w-full px-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "w-full px-2 py-4 mx-auto text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_FooterSection = _resolveComponent("FooterSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.descargar && _ctx.descargar(...args))),
          class: "px-4 py-2 bg-white border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl"
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-arrow-circle-down mr-2" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('boton.descargar.credencial')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.formData.link
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.salir && _ctx.salir(...args))),
          class: "px-4 py-2 bg-white border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl"
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-sign-out mr-2" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('global.salir')), 1)
        ])
      ])
    ]),
    _createVNode(_component_FooterSection)
  ], 64))
}